import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './MainMenu.scss';
import iconsSvg from '../../assets/img/svgLib/iconsSvg';
import Dropdown from 'react-dropdown';
import classNames from 'classnames';

class MainMenu extends Component {
    static propTypes = {
      userInfo: PropTypes.object,
      classPrefix: PropTypes.string,
      activeMenu: PropTypes.string,
      handelMainMenuItem: PropTypes.func,
      basketCnt: PropTypes.number,
      switchOntoTable: PropTypes.func,
    }

    constructor(props) {
      super(props);

      this.state = {
        dropDownCategoryActive: '',
        dropDownCategory: [
          {value: 0, label: 'Нефтяная промышленность'},
        ],
        navMenuItems: this.props.userInfo.role === 'admin' ? [] : [
          {key: 'supply', val: 'Поставки'},
          {key: 'vendor', val: 'Поставщики'},
          {key: 'debtor', val: 'Дебиторы'},
        ],
        role: 'factor', // this.props.userInfo.role,
        navMenuItemActive: this.props.activeMenu,
        userInfo: this.props.userInfo,
      };
    }

    componentWillReceiveProps(nextProps) {
      this.setState({
        nextProps,
        navMenuItems: nextProps.userInfo.role === 'admin' ? [] : [
          {key: 'supply', val: 'Поставки'},
          {key: 'vendor', val: 'Поставщики'},
          {key: 'debtor', val: 'Дебиторы'},
        ],
      });
    }

    handleDropDownCategory = (e) => {
      this.setState({
        dropDownCategoryActive: e.value,
      });
    }

    handleNavMenu = (event) => {
      const {handelMainMenuItem, switchOntoTable} = this.props;
      const value = event.currentTarget.dataset.value;

      this.setState({
        navMenuItemActive: value,
      });
      handelMainMenuItem(value);
      value === 'vendor' || value === 'debtor' && switchOntoTable(true);
    }

  linkToSite = () => {
    return window.location.href = 'http://factoroil.com/';

  };

    menu() {
      const {classPrefix, userInfo, basketCnt} = this.props;
      const {dropDownCategory, navMenuItems, navMenuItemActive} = this.state;

      return (<div className={`mainMenu${classPrefix}`}>
        {classPrefix ? (
                <div className={`gamburger${classPrefix}`}>
                  {iconsSvg.gamburger}
                </div>
            ) : null}
        <div className={`mainMenuIcon`} onClick={this.linkToSite}>
                Factoroil
        </div>
        {!classPrefix ? (
                <div className={`mainMenuItems`}>
                  <Dropdown
                    options={dropDownCategory}
                    value={dropDownCategory[0]}
                    menuClassName={'dropDownMenu'}
                    arrowClassName={'arrowDropMenu'}
                    onChange={this.handleDropDownCategory} />
                </div>
            ) : null}
        {!classPrefix ? (<div className={'navMenu'}>
          {navMenuItems.map((item, i) => {
            return (<div
              key={`main_${i}`}
              className={classNames('navMenuItem',
                  {'active': item.key === navMenuItemActive})}
              data-value={item.key}
              onClick={this.handleNavMenu} >
              {item.val}
            </div>);
          })}
        </div>) : null}
        {userInfo.role !== 'admin' ? (
                <div className={`basket${classPrefix}`}
                  data-value={'basket'}
                  onClick={this.handleNavMenu}>
                  {iconsSvg.basket}
                  <div className={'amount'}>{basketCnt}</div>
                </div>
            ) : null}
        {classPrefix ? (
                <div className={`userAvatar${classPrefix}`}>
                  <div className={'userAvatarIcon'}>
                        Ф.И.
                  </div>
                </div>
            ) : (
                <div className={'callCenterNumber'} />
            )}
      </div>); /* TODO Передавать инициалы в аватар*/
    }

    render() {
      return this.menu();
    }
}

export default MainMenu;



// WEBPACK FOOTER //
// ./src/shared/MainMenu/MainMenu.js